import React, { useState } from 'react'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import { Box } from '@mui/material'

const withLoading = (WrappedComponent) => {
  return function WithLoadingComponent(props) {
    const [loader, setLoader] = useState(false)

    return (
      <BlockUi
        blocking={loader}
        loader={
          <PacmanLoader color={'var(--primary)'} loading={loader} />
        }
        message={
          <Box sx={{ color: '#368cff' }}>Creating Account</Box>
        }
      >
        <WrappedComponent
          {...props}
          setLoader={setLoader}
          loader={loader}
        />
      </BlockUi>
    )
  }
}

export default withLoading
